import { ActionIcon, Menu } from "@mantine/core";
import { IconDots } from "@tabler/icons-react";

export function HeldEmailRowActionsTrigger() {
  return (
    <Menu.Target>
      <ActionIcon aria-label="Queued email actions" variant="subtle">
        <IconDots size={18} />
      </ActionIcon>
    </Menu.Target>
  );
}
